module.exports = __webpack_public_path__ + "static/home_o_nas-8dc391338f37bc98452be0222996bc9e.jpg";